import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMCommitCriteriaAsync,
  deleteOMCommitCriteriaAsync,
  editOMCommitCriteriaAsync,
  getOMCommitCriteriaAsync,
} from "../../../store/services/orderManagementService";
const CommitCriteria = () => {
  const dispatch = useDispatch();
  const {
    getOMCommitCriteriaStatus,
    getOMCommitCriteriaError,
    getOMCommitCriteriaData,
    addOMCommitCriteriaStatus,
    addOMCommitCriteriaData,
    addOMCommitCriteriaError,

    editOMCommitCriteriaStatus,
    editOMCommitCriteriaError,
    editOMCommitCriteriaData,

    deleteOMCommitCriteriaData,
    deleteOMCommitCriteriaStatus,
    deleteOMCommitCriteriaError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMCommitCriteriaAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMCommitCriteriaData?.length
    ? getOMCommitCriteriaData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedCommitCriteria, setSelectedCommitCriteria] = useState();
  const [addCommitCriteriaMode, setAddCommitCriteriaMode] = useState(false);
  const [addCommitCriteriaData, setAddCommitCriteriaData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedCommitCriteria", selectedCommitCriteria);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMCommitCriteriaStatus === asyncStatus.SUCCEEDED) {
      setAddCommitCriteriaMode(false);
      setSaveDisabled(true);
      setAddCommitCriteriaData();
    }
  }, [, addOMCommitCriteriaStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMCommitCriteriaAsync(selectedCommitCriteria?.commit_criteria_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMCommitCriteriaStatus === asyncStatus.SUCCEEDED || deleteOMCommitCriteriaStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedCommitCriteria();
    }
  }, [, deleteOMCommitCriteriaStatus]);
  useEffect(() => {
    if (editOMCommitCriteriaStatus === asyncStatus.SUCCEEDED) {
      setSelectedCommitCriteria();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMCommitCriteriaStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this commit criteria?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Commit Criteria"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Commit Criteria
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddCommitCriteriaMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addCommitCriteriaMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addCommitCriteriaMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddCommitCriteriaMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addCommitCriteriaMode || !selectedCommitCriteria}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMCommitCriteriaStatus === asyncStatus.LOADING ||
                  editOMCommitCriteriaStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addCommitCriteriaData) {
                    dispatch(addOMCommitCriteriaAsync(addCommitCriteriaData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedCommitCriteria, ...editData };
                    delete a.id;
                    dispatch(editOMCommitCriteriaAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "commit_criteria_id", headerName: "ID", flex: true },
                  { field: "commit_criteria_name", headerName: "Commit Criteria", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedCommitCriteria(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMCommitCriteriaStatus === asyncStatus.IDLE ||
                  getOMCommitCriteriaStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addCommitCriteriaMode ? (
              <InputWithBtnLayoutComp
              error={addOMCommitCriteriaError}
                inputArray={[
                  {
                    label: "Commit Criteria:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddCommitCriteriaData({
                            ...addCommitCriteriaData,
                            commit_criteria_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddCommitCriteriaData({
                            ...addCommitCriteriaData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedCommitCriteria ? (
              <InputWithBtnLayoutComp
              error={editOMCommitCriteriaError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedCommitCriteria?.commit_criteria_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Commit Criteria:",
                    comp: (
                      <InputComp
                        key={selectedCommitCriteria?.commit_criteria_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            commit_criteria_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedCommitCriteria?.commit_criteria_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedCommitCriteria?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedCommitCriteria?.is_active || editData?.is_active}
                        defaultChecked={selectedCommitCriteria?.is_active || editData?.is_active}
                        // checked={selectedCommitCriteria?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any commit criteria</Typography>
              <Typography color={"red"} fontSize={12}>{getOMCommitCriteriaError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedCommitCriteria(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedCommitCriteria(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default CommitCriteria;
